import {
  createCrudActions,
  createCrudActionTypes,
  createCrudMutation,
  createCrudState,
  createExportActions,
  createExportActionTypes,
  createExportMutation,
  createExportState
} from 'vuex-module-generator';

import { Message } from 'element-ui';
import i18n from '@/i18n';
import errorResolver from '@/helpers/errorResolver';
import { fetchSkus } from '@/shared/apis';
import { exportAllSkus, exportNonSkus } from './api';

export const allSkusTypes = {
  ...createCrudActionTypes('ALL_SKUS'),
  ...createExportActionTypes('ALL_SKUS')
};

export const Visitstate = () => ({
  list: createCrudState().list,
  ...createExportState()
});

export const mutations = {
  ...createCrudMutation(allSkusTypes),
  ...createExportMutation(allSkusTypes)
};

export const actions = createCrudActions(allSkusTypes);
export const exportAction = createExportActions(allSkusTypes);

export default {
  state: Visitstate,
  mutations,
  actions: {
    cleanAllSkusList({ commit }) {
      commit(actions.clean.list());
    },
    async fetchAllSkus({ commit }, { projectId, pagination }) {
      commit(actions.index.request());
      try {
        const res = await fetchSkus(projectId, pagination);
        commit(actions.index.success(res.data));

        return Promise.resolve(res);
      } catch (error) {
        commit(actions.index.failure(error));

        return Promise.reject(error);
      }
    },
    async exportAllSkus({ commit }, { projectId, query }) {
      commit(exportAction.export.request());
      try {
        await exportAllSkus(projectId, query);
        Message({ type: 'success', message: i18n.t('Export request has been sent. Check your email after a few minutes') });
        commit(exportAction.export.success());

        return Promise.resolve();
      } catch (error) {
        const { message } = errorResolver(error);
        Message({ type: 'error', message });
        commit(exportAction.export.failure(error));

        return Promise.reject(error);
      }
    },
    async exportNonSkus({ commit }, { projectId, query }) {
      commit(exportAction.export.request());
      try {
        await exportNonSkus(projectId, query);
        Message({ type: 'success', message: i18n.t('Export request has been sent. Check your email after a few minutes') });
        commit(exportAction.export.success());

        return Promise.resolve();
      } catch (error) {
        const { message } = errorResolver(error);
        Message({ type: 'error', message });
        commit(exportAction.export.failure(error));

        return Promise.reject(error);
      }
    }
  }
};
